import { Button } from "../../components/forms";
import { GoPlus } from "react-icons/go";
 import { usePickerhook } from "../../hooks/usePickerhook";
 
import { useState } from "react";
 
import { NoDepartment } from "../../components/users/NoDepartment";
import AddDepartment from "../../components/users/AddDepartment";
import { useDeptHook } from "../../hooks/useDeptHook";
import { DepartmentItem } from "../../components/users/DepartmentIem";

const Department = () => {

    const rolepicked = usePickerhook();
    const [entered, setentered] =useState("")
    const {AllOrgDepts,refresh} =useDeptHook()
    const users =[1,2,3,4,5,6]
    const [showadddept,setshowadddept]=useState(false)

    const onChange =((e:string)=>{


setentered(e)
    })




  return (
    <div className="w-full pr-20  flex  ">
      {showadddept&& <AddDepartment  refresh={refresh} show={setshowadddept}/>}
      <div className={` p-6 bg-white    w-full  rounded-[20px]`}>
        <div className="  w-full  flex justify-between items-center  ">
          <p className="text-textbg font-medium text-sm mb-2 text-[16px] bg-white">
            Department  
          </p>

          <Button
            width={200}
            disabled={false}
            text={
              <>
                {" "}
                <GoPlus size={15} className=" mx-1 inline" /> Add department
              </>
            }
            onBtnClick={() => {setshowadddept(true)}}
          />
        </div>
        
        <hr/>

{AllOrgDepts. length>0?
<div className="py-4">

{AllOrgDepts.map((i:any)=>(<DepartmentItem item={i}/>))}

</div>:


        <div  className="flex justify-center items-center">
          <NoDepartment  add={setshowadddept}/>
 
        </div>}
      </div>
    </div>
  );
};
export { Department };
